import React from 'react';
import {
    FaBitcoin,
    FaEthereum,
    FaCopy,
    FaTimes,
    FaHeart
} from 'react-icons/fa';
import { SiLitecoin } from 'react-icons/si';
import "../styles/DonateModal.css";

const DonateModal = ({ isOpen, onClose }) => {
    const copyToClipboard = (text) => {
        navigator.clipboard.writeText(text);
        alert(`Copied to clipboard: ${text}`); // Optional alert to confirm copy action
    };

    if (!isOpen) return null;

    return (
        <div className="modal-overlay">
            <div className="modal-content glass-morphism">
                <button className="modal-close" onClick={onClose}>
                    <FaTimes />
                </button>

                <div className="modal-header">
                    <FaHeart className="modal-icon" />
                    <h2>Support FaceitFinder</h2>
                    <p>Thank you for considering supporting our project! You can donate using these cryptocurrency addresses:</p>
                </div>

                <div className="crypto-list">
                    <div className="crypto-item">
                        <div className="crypto-header">
                            <FaBitcoin className="crypto-icon bitcoin"/>
                            <span>Bitcoin (BTC)</span>
                        </div>
                        <div className="crypto-address">
                            <code>bc1q4ld9nzmgnn8hvq8jtvf58tlytnwdpden7x458r</code>
                            <button
                                className="copy-button"
                                onClick={() => copyToClipboard('16k1coQiea6ZekGbu65khkQUwgbeytuDAv')}
                            >
                                <FaCopy/>
                            </button>
                        </div>
                    </div>

                    <div className="crypto-item">
                        <div className="crypto-header">
                            <FaEthereum className="crypto-icon ethereum"/>
                            <span>Ethereum (ETH Network]</span>
                        </div>
                        <div className="crypto-address">
                            <code>0x5b843C4e9Bc24d4A0c58506fd7dE1B3cf6480893</code>
                            <button
                                className="copy-button"
                                onClick={() => copyToClipboard('0x6d89262064454f2059887f029731cea9ba7845cf')}
                            >
                                <FaCopy/>
                            </button>
                        </div>
                    </div>

                    <div className="crypto-item">
                        <div className="crypto-header">
                            <FaEthereum className="crypto-icon tether"/>
                            <span>USDT [ETH Network]</span>
                        </div>
                        <div className="crypto-address">
                            <code>0x5b843C4e9Bc24d4A0c58506fd7dE1B3cf6480893</code>
                            <button
                                className="copy-button"
                                onClick={() => copyToClipboard('TKdycCmz7GecH354dV6cVi2CwSig5qgNQP')}
                            >
                                <FaCopy/>
                            </button>
                        </div>
                    </div>

                    <div className="crypto-item">
                        <div className="crypto-header">
                            <SiLitecoin className="crypto-icon litecoin"/>
                            <span>Litecoin (LTC Network)</span>
                        </div>
                        <div className="crypto-address">
                            <code>LXn4xojed4D3WwLeHbRwtecWGnUXXMq7Mx</code>
                            <button
                                className="copy-button"
                                onClick={() => copyToClipboard('La3186VS1wDpTJdjSRymR1MBVSPGzdr22J')}
                            >
                                <FaCopy/>
                            </button>
                        </div>
                    </div>

                    <div className="crypto-item">
                        <div className="crypto-header">
                            <SiLitecoin className="crypto-icon litecoin"/>
                            <span>Solana (SOL Network)</span>
                        </div>
                        <div className="crypto-address">
                            <code>4dDYPUf46LkKmqmyvK5yq9183QVi3FvuDMbzWzgqnEVD</code>
                            <button
                                className="copy-button"
                                onClick={() => copyToClipboard('La3186VS1wDpTJdjSRymR1MBVSPGzdr22J')}
                            >
                                <FaCopy/>
                            </button>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    );
};

export default DonateModal;
